// extracted by mini-css-extract-plugin
export default {"container":"Main_container__uzGJG","sidebar":"Main_sidebar__Y9Nta","content":"Main_content__nSVM4"};